// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import { getAdminMenuItems } from 'menu-items/admins-menu';
import { getTeacherMenuItems } from 'menu-items/teachers-menu';
import { getGradingMenu } from 'menu-items/grading';

import { useRecoilValue } from 'recoil';
import { LoggedInState } from 'states/LoggedIn';
import { AcademyState } from 'states/Academy';
import { gradingAcademyState, gradingMenuSignalState, gradingNodesDownState, gradingReviewCountState } from 'states/GradingOverview';

const MenuList = () => {
  const loggedIn = useRecoilValue(LoggedInState)
  const academyState = useRecoilValue(AcademyState)
  const gradingAcademy = useRecoilValue(gradingAcademyState)
  const gradingSignal = useRecoilValue(gradingMenuSignalState)
  const gradingReviewCount = useRecoilValue(gradingReviewCountState)
  const gradingNodesDown = useRecoilValue(gradingNodesDownState)

  var menuItem = null;
  if (loggedIn.user.type === "A") {
    if (academyState == null) {
      menuItem = getAdminMenuItems()
    } else {
      menuItem = getTeacherMenuItems()
    }
  } else if (loggedIn.user.type === "T") {
    menuItem = getTeacherMenuItems()
  }
  if (menuItem == null) {
    return <div>Wrong Access</div>
  }
  const groups = gradingAcademy == null
    ? menuItem.items
    : [...menuItem.items, getGradingMenu(gradingSignal, gradingReviewCount, { operator: loggedIn.user.type === "A", nodesDown: gradingNodesDown })]
  const navItems = groups.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default MenuList;
